<div class="page">
  @if (store.loading() && !company()) {
    <app-spinner></app-spinner>
  } @else if (store.failed()) {
    <div class="state">
      <lib-no-data icon="cloud_off" message="companies.errors.load_one"></lib-no-data>
      <lib-button color="secondary" icon="refresh" [text]="'companies.retry' | translate" (click)="store.reload()"></lib-button>
    </div>
  } @else if (company()) {
    <header class="head">
      <h1>{{ 'synthesis.title' | translate }}</h1>
      <p>{{ 'synthesis.pick_tenant' | translate: { name: company()!.name } }}</p>
    </header>

    <div class="tenant-grid">
      @for (tenant of tenants(); track tenant.id) {
        <article class="tenant-card" [style.--tenant-color]="tenant.color">
          <span class="tenant-icon"><mat-icon>{{ tenant.icon }}</mat-icon></span>

          <span class="tenant-body">
            <a class="tenant-name" [routerLink]="['/synthesis', tenant.id, 'prevention']">{{ tenant.name }}</a>

            @if (tenant.projects.length) {
              <button type="button" class="tenant-count clickable" [matMenuTriggerFor]="projectsMenu"
                [matMenuTriggerData]="{ tenant: tenant }" (click)="$event.stopPropagation()">
                {{ 'companies.projects_count' | translate: { count: tenant.projects.length } }}
                <mat-icon>expand_more</mat-icon>
              </button>
            } @else {
              <span class="tenant-count">{{ 'companies.projects_count' | translate: { count: 0 } }}</span>
            }
          </span>

          <mat-icon class="tenant-go">chevron_right</mat-icon>
        </article>
      } @empty {
        <div class="state">
          <lib-no-data icon="category" message="companies.no_tenants"
            [description]="canManageTenants() ? 'synthesis.no_tenants_desc' : ''">
          </lib-no-data>

          @if (canManageTenants()) {
            <lib-button icon="add" (click)="createTenant()" [text]="'companies.tenant_add' | translate"></lib-button>
          }
        </div>
      }
    </div>
  } @else {
    <div class="state">
      <lib-no-data icon="domain_disabled" message="companies.none" description="companies.none_desc"></lib-no-data>
    </div>
  }
</div>

<mat-menu #projectsMenu="matMenu">
  <ng-template matMenuContent let-tenant="tenant">
    <ul class="project-list">
      @for (project of tenant.projects; track project.id) {
        <li>
          {{ project.name }}
          @if (project.city; as city) {
            <small>{{ city }}</small>
          }
        </li>
      }
    </ul>
  </ng-template>
</mat-menu>
